import type { Configuration } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_AZURE_TENANT_ID ?? '';
const clientId = import.meta.env.VITE_AZURE_CRM_CLIENT_ID ?? '';

// T1-055E Round 2 Finding A — apiScopes wiring. The backend API app
// registration (clientId fae337b4-fc9a-4758-bee6-d3df9339cd43) exposes the
// `access_as_user` scope; the CRM SPA's delegated permission to that scope
// has admin consent granted in the staging Entra tenant. The full scope URI
// is `api://<api-client-id>/access_as_user`. Injected at build time via
// VITE_AZURE_API_SCOPE; empty fallback for local dev keeps the type but
// MsalAuthenticationTemplate-driven token acquisition will return a token
// with no API audience until the env var is populated.
const apiScope = import.meta.env.VITE_AZURE_API_SCOPE ?? '';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: tenantId ? `https://login.microsoftonline.com/${tenantId}` : '',
    redirectUri: typeof window !== 'undefined' ? window.location.origin : '',
    postLogoutRedirectUri: typeof window !== 'undefined' ? window.location.origin : '',
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // T-CRM-AUTH-401-FIX, revisited in QA 2026-10-01 F-07: the token cache
    // stays in localStorage, which every CRM tab and window shares. The cost:
    // any script running on the CRM origin can read the cached tokens,
    // refresh token included. sessionStorage survives reloads but is per tab,
    // so every new tab (email and Teams deep links, middle-click, bookmarks)
    // would start empty and land on sign-in; that multi-tab break rules it
    // out. The mitigation is the CSP (F-34, public/staticwebapp.config.json):
    // scripts load only from the CRM's own origin, never inline or eval'd.
    //
    // storeAuthStateInCookie (msal-browser 3.30) copies only the temporary
    // redirect state (state, nonce, authority, return URL, request params
    // with the PKCE verifier) into first-party SameSite=Lax cookies beside
    // sessionStorage, so a redirect sign-in still validates if sessionStorage
    // is lost on the way back. No tokens go in cookies, and it does nothing
    // for third-party cookie blocking: the hidden renewal iframe still needs
    // Microsoft's own session cookies, and when the browser withholds them
    // the InteractionRequiredAuthError path in api/client.ts redirects.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

export const apiScopes: string[] = apiScope ? [apiScope] : [];
